import { useState } from "react";
import { useTranslations } from "use-intl";
import clsx from "clsx";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

import { Image } from "../Image";
import { useLocaleInfo } from "@/app/lib/hooks/useLocaleInfo";
import { CheckoutDrawer } from "../CheckoutBanner";

const bannerUrls = [{ url: "/banners/banner.jpg", alt: "Banner 1" }];

export const OffersCarousel = () => {
  const t = useTranslations();
  const { dir } = useLocaleInfo();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [sliderRef] = useKeenSlider<HTMLDivElement>({
    loop: true,
    slides: {
      perView: "auto",
      spacing: 8,
      origin: "center",
    },
    renderMode: "performance",
    rtl: dir === "rtl",
  });

  return (
    <div className="max-w-full">
      <h6 className="mb-4 px-4 text-xl font-bold text-text-title">
        {t("offers.carouselTitle")}
      </h6>

      <div
        className={clsx({
          "px-4": bannerUrls.length < 2,
        })}
      >
        <div ref={sliderRef} className="keen-slider">
          {bannerUrls.map(({ url, alt }, index) => (
            <div
              key={url}
              className="keen-slider__slide w-8/10 min-w-8/10 rounded-2xl"
            >
              <Image
                src={url}
                alt={alt}
                className="size-full object-cover"
                fetchPriority={index === 0 ? "high" : "auto"}
                onClick={() => setDrawerOpen(true)}
              />
            </div>
          ))}
        </div>
      </div>

      <CheckoutDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </div>
  );
};
